import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //狀態
    isLogin: false,
    userId: "",
    userNa: "",
    depsNo: "",
    isAdmin: false
  },
  mutations: {
    //改狀態的方法(只能從這邊改)
    setLogIn(state,paylod){state.isLogin =paylod},    
    setUsrId(state,paylod){state.userId  =paylod},
    setUsrNa(state,paylod){state.userNa  =paylod},
    setDepNo(state,paylod){state.depsNo  =paylod},
    setAdmin(state,paylod){state.isAdmin =paylod},
  },
  actions: {
  },
  modules: {
  }
})
